import React from 'react';
// import { Link } from 'react-router-dom';
// import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div>
                    <h1>Footer</h1>
                </div>
            </footer>
        </>
    )
}
export default Footer;
